import { render, staticRenderFns } from "./DiarioDeClasse.vue?vue&type=template&id=40805e97&scoped=true&"
import script from "./DiarioDeClasse.vue?vue&type=script&lang=js&"
export * from "./DiarioDeClasse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40805e97",
  null
  
)

export default component.exports